const NO_TRACKING_STORAGE_KEY = 'no-tracking';

function isTrackingDisabled() {
  try {
    return localStorage.getItem(NO_TRACKING_STORAGE_KEY) !== null;
  } catch {
    return false;
  }
}

function shouldTrack() {
  return (
    process.env.NODE_ENV === 'production' && !isTrackingDisabled()
  );
}

function isDemoMode() {
  try {
    return window.location.pathname === "/demo";
  } catch {
    return false;
  }
}

// Simple debounce utility
function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

export function trackEvent({ action, data }) {
  const eventAction = isDemoMode() ? `demo_${action}` : action;
  if (shouldTrack()) {
    if (typeof window.umami?.track === 'function') {
      window.umami.track(eventAction, data);
    }
  }
  if (process.env.NODE_ENV === 'development') {
    console.log('track event', eventAction, data);
  }
}

// Debounced version for field value changes (500ms delay)
export const debouncedTrackEvent = debounce(trackEvent, 500);

// format:
// 4" × 3" (101mm × 76mm) — Custom
export const getBadgeSizeTrackingValue = (basgeSize) => {
  const suffix = basgeSize.isCustomSize ? " — Custom" : "";
  if (basgeSize.displayMmOnly) {
    return `${basgeSize.displaySizeInMm}${suffix}`;
  }
  return `${basgeSize.displayWidth} × ${basgeSize.displayHeight} (${basgeSize.displaySizeInMm})${suffix}`;
};
